/**
 * Created by yvesb on 22/10/2016.
 */
/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const Nat = require('./Nat')

/**
 *
 * @type NatCal
 */
const NatCal = {
  NAucunCalcul              : new Nat(0, 0),
  NVariable                 : new Nat(1, 0),
  NCalculReel               : new Nat(1 << 1, 0),
  NCalculReelConstant       : new Nat(1 << 2, 0),
  NSuiteRecurrenteReelle    :	new Nat(1 << 3, 0),
  NSuiteRecurrenteComplexe  :	new Nat(1 << 4, 0),
  NSolutionEquation         : new Nat(1 << 5, 0),
  NIntegrale                :	new Nat(1 << 6, 0),
  NTestExistence            : new Nat(1 << 7, 0),
  NSommeIndicee             : new Nat(1 << 8, 0),
  NPartieReelle             : new Nat(1 << 9, 0),
  NPartieImaginaire         :	new Nat(1 << 10, 0),
  NModule                   : new Nat(1 << 11, 0),
  NArgument                 : new Nat(1 << 12, 0),
  NMesureLongueur           : new Nat(1 << 13, 0),
  NMesureAngleNonOriente    : new Nat(1 << 14, 0),
  NMesureAngleOriente       : new Nat(1 << 15, 0),
  NMesureAbscisseSurDroite  :	new Nat(1 << 16, 0),
  NMesureAbscisseRepere     :	new Nat(1 << 17, 0),
  NMesureOrdonneeRepere     :	new Nat(1 << 18, 0),
  NMesureLongueurLigne      :	new Nat(1 << 19, 0),
  NMesureAirePolygone       : new Nat(1 << 20, 0),
  NCalculComplexe           : new Nat(1 << 21, 0),
  NFonction                 : new Nat(1 << 22, 0),
  NDerivee                  : new Nat(1 << 23, 0),
  NFonctionComplexe         : new Nat(1 << 24, 0),
  NMesureAffixe             : new Nat(1 << 25, 0),
  NRepere                   : new Nat(1 << 26, 0),
  NMesureCoefDir            : new Nat(1 << 27, 0),
  NMesureProduitScalaire    : new Nat(1 << 28, 0),
  NProduitIndice            : new Nat(1 << 29, 0),
  NFonction2Var             : new Nat(1 << 30, 0),
  NFonction3Var             : new Nat(0, 1 << 1), // JavaScript pas plus de 31 bits pour entier non signé
  NFonctionComplexe2Var     : new Nat(0, 1 << 2), // 2^33 // Pas de décalages de plus de 32 bits en javascript
  NFonctionComplexe3Var     : new Nat(0, 1 << 3), // 2^34
  NMaximumFonction          : new Nat(0, 1 << 4), // 2^35
  NMinimumFonction          : new Nat(0, 1 << 5), // 2^36
  NAbscisseOrigineRep       : new Nat(0, 1 << 6), // 2^37
  NOrdonneeOrigineRep       : new Nat(0, 1 << 7), // 2^38
  NUnitexRep                : new Nat(0, 1 << 8), // 2^39
  NUniteyRep                : new Nat(0, 1 << 9), // 2^40
  NTestEquivalence          : new Nat(0, 1 << 10), // 2^41
  NDeriveePartielle         : new Nat(0, 1 << 11), // 2^42
  NTestDependanceVariable   : new Nat(0, 1 << 12), // 2^43
  NTestNatureOperateur      : new Nat(0, 1 << 13), // 2^44
  NSuiteRecurrenteComplexe2 : new Nat(0, 1 << 14), // 2^45
  NSuiteRecurrenteReelle2   : new Nat(0, 1 << 15), // 2^46
  NSuiteRecurrenteComplexe3 : new Nat(0, 1 << 16), // 2^47
  NSuiteRecurrenteReelle3   : new Nat(0, 1 << 17), // 2^48
  // Spécial JavaScript pour fonctions de 4 variables ou plus
  // Abandonné
  /*
  NFonctionNVar             : new Nat(0, 1 << 18), // 2^49)
  NFonctionComplexeNVar     : new Nat(0, 1 << 19), // 2^50)
  // Rajout version 4.7.9
  NTestFact                 : new Nat(0, 1 << 20), // 2^51)

  nombreTypesObjetsCalcul : 50
  */
  NTestFact                 : new Nat(0, 1 << 18), // 2^49)

  nombreTypesObjetsCalcul : 48

};


NatCal.NFoncPlusieursVar = Nat.or(NatCal.NFonction2Var , NatCal.NFonction3Var);
NatCal.NFoncCPlusieursVar = Nat.or(NatCal.NFonctionComplexe2Var, NatCal.NFonctionComplexe3Var);
NatCal.NFoncR1Var = Nat.or(NatCal.NFonction , NatCal.NDerivee);
NatCal.NTteFoncR = Nat.or(NatCal.NFoncR1Var , NatCal.NFoncPlusieursVar
  , NatCal.NDeriveePartielle);
NatCal.NTteFoncC = Nat.or(NatCal.NFonctionComplexe , NatCal.NFoncCPlusieursVar);
NatCal.NTteFoncRouC = Nat.or(NatCal.NTteFoncR , NatCal.NTteFoncC);
NatCal.NTteValR = Nat.or(NatCal.NVariable , NatCal.NCalculReel, NatCal.NCalculReelConstant
  , NatCal.NSolutionEquation, NatCal.NIntegrale, NatCal.NTestExistence , NatCal.NSommeIndicee
  , NatCal.NProduitIndice , NatCal.NPartieReelle , NatCal.NPartieImaginaire
  , NatCal.NModule , NatCal.NArgument , NatCal.NMesureLongueur
  , NatCal.NMesureAngleNonOriente ,NatCal.NMesureAngleOriente , NatCal.NMesureAbscisseSurDroite
  , NatCal.NMesureAbscisseRepere , NatCal.NMesureOrdonneeRepere
  , NatCal.NMesureLongueurLigne , NatCal.NMesureAirePolygone , NatCal.NMesureCoefDir
  , NatCal.NMesureProduitScalaire , NatCal.NMaximumFonction , NatCal.NMinimumFonction
  , NatCal.NAbscisseOrigineRep , NatCal.NOrdonneeOrigineRep , NatCal.NUnitexRep
  , NatCal.NUniteyRep , NatCal.NTestEquivalence, NatCal.NTestFact, NatCal.NTestDependanceVariable
  , NatCal.NTestNatureOperateur);
NatCal.NTteValRSaufConst = Nat.or(NatCal.NVariable , NatCal.NCalculReel
  , NatCal.NSolutionEquation , NatCal.NIntegrale, NatCal.NTestExistence
  , NatCal.NSommeIndicee , NatCal.NProduitIndice , NatCal.NPartieReelle
  , NatCal.NPartieImaginaire , NatCal.NModule , NatCal.NArgument
  , NatCal.NMesureLongueur, NatCal.NMesureAngleNonOriente, NatCal.NMesureAngleOriente
  , NatCal.NMesureAbscisseSurDroite , NatCal.NMesureAbscisseRepere
  , NatCal.NMesureOrdonneeRepere, NatCal.NMesureLongueurLigne
  , NatCal.NMesureAirePolygone , NatCal.NMesureCoefDir
  , NatCal.NMesureProduitScalaire , NatCal.NMaximumFonction
  , NatCal.NMinimumFonction , NatCal.NAbscisseOrigineRep
  , NatCal.NOrdonneeOrigineRep , NatCal.NUnitexRep , NatCal.NUniteyRep
  , NatCal.NTestEquivalence, NatCal.NTestFact, NatCal.NTestDependanceVariable
  , NatCal.NTestNatureOperateur);
// Utilisé seulement dans l'applet :
NatCal.NTtCalcRNommeSaufConst = Nat.or(NatCal.NVariable , NatCal.NCalculReel
  , NatCal.NSolutionEquation , NatCal.NIntegrale, NatCal.NTestExistence
  , NatCal.NSommeIndicee , NatCal.NProduitIndice , NatCal.NPartieReelle
  , NatCal.NPartieImaginaire , NatCal.NModule , NatCal.NArgument
  , NatCal.NMesureLongueurLigne , NatCal.NMesureAirePolygone , NatCal.NMesureCoefDir
  , NatCal.NMesureProduitScalaire , NatCal.NMaximumFonction , NatCal.NMinimumFonction
  , NatCal.NAbscisseOrigineRep , NatCal.NOrdonneeOrigineRep , NatCal.NUnitexRep
  , NatCal.NUniteyRep , NatCal.NTestEquivalence, NatCal.NTestFact, NatCal.NTestDependanceVariable
  , NatCal.NTestNatureOperateur);

NatCal.NTteValC = Nat.or(NatCal.NCalculComplexe , NatCal.NMesureAffixe);
NatCal.NCalcRouC = Nat.or(NatCal.NCalculReel , NatCal.NCalculComplexe);
NatCal.NTteValOuFoncR = Nat.or(NatCal.NTteValR , NatCal.NTteFoncR
  , NatCal.NSuiteRecurrenteReelle , NatCal.NSuiteRecurrenteReelle2 , NatCal.NSuiteRecurrenteReelle3);
NatCal.NTteValROuC = Nat.or(NatCal.NTteValR , NatCal.NTteValC);
/*
NatCal.NTteValRouCouFoncC = Nat.or(NatCal.NTteValROuC
  , NatCal.NTteFoncC , NatCal.NSuiteRecurrenteComplexe
  , NatCal.NSuiteRecurrenteComplexe2 , NatCal.NSuiteRecurrenteComplexe3);
*/
/*
NatCal.NTteValRouCSaufConst = Nat.or(NatCal.NTteValRSaufConst, NatCal.NTteValC);
*/

NatCal.NTteValPourComDynSaufFonc = Nat.or(NatCal.NVariable , NatCal.NCalculReel
  ,NatCal.NCalculReelConstant , NatCal.NCalculComplexe, NatCal.NSolutionEquation
  , NatCal.NIntegrale , NatCal.NTestExistence , NatCal.NSommeIndicee , NatCal.NProduitIndice
  , NatCal.NPartieReelle, NatCal.NPartieImaginaire , NatCal.NModule
  , NatCal.NArgument , NatCal.NMesureLongueurLigne , NatCal.NMesureAirePolygone
  , NatCal.NMesureCoefDir	, NatCal.NMesureProduitScalaire , NatCal.NMaximumFonction
  , NatCal.NMinimumFonction, NatCal.NAbscisseOrigineRep , NatCal.NOrdonneeOrigineRep
  , NatCal.NUnitexRep , NatCal.NUniteyRep, NatCal.NTestEquivalence, NatCal.NTestFact
  , NatCal.NTestDependanceVariable , NatCal.NTestNatureOperateur
  ,NatCal.NMesureAbscisseSurDroite, NatCal.NMesureAbscisseRepere
  ,NatCal.NMesureOrdonneeRepere, NatCal.NMesureAngleOriente,NatCal.NMesureAffixe);

NatCal.NTteValRPourComDyn = Nat.or(NatCal.NVariable
  , NatCal.NCalculReel ,NatCal.NCalculReelConstant
  , NatCal.NSolutionEquation , NatCal.NIntegrale , NatCal.NTestExistence
  , NatCal.NSommeIndicee, NatCal.NProduitIndice , NatCal.NPartieReelle
  , NatCal.NPartieImaginaire , NatCal.NModule , NatCal.NArgument
  , NatCal.NMesureLongueurLigne , NatCal.NMesureAirePolygone , NatCal.NMesureCoefDir
  , NatCal.NMesureProduitScalaire , NatCal.NMaximumFonction , NatCal.NMinimumFonction
  , NatCal.NAbscisseOrigineRep , NatCal.NOrdonneeOrigineRep , NatCal.NUnitexRep
  , NatCal.NUniteyRep, NatCal.NTestEquivalence, NatCal.NTestFact, NatCal.NTestDependanceVariable
  , NatCal.NTestNatureOperateur,NatCal.NMesureAbscisseSurDroite
  , NatCal.NMesureAbscisseRepere,NatCal.NMesureOrdonneeRepere);

NatCal.NTteValPourComDyn = Nat.or(NatCal.NTteValPourComDynSaufFonc
  , NatCal.NTteFoncRouC);
NatCal.NFoncouSuiteR = Nat.or(NatCal.NTteFoncR , NatCal.NSuiteRecurrenteReelle
  , NatCal.NSuiteRecurrenteReelle2 , NatCal.NSuiteRecurrenteReelle3);
NatCal.NFoncouSuiteC = Nat.or(NatCal.NTteFoncC , NatCal.NSuiteRecurrenteComplexe
  ,NatCal.NSuiteRecurrenteComplexe2, NatCal.NSuiteRecurrenteComplexe3);
/*
NatCal.NCalcouVarouFoncRouC = Nat.or(NatCal.NVariable , NatCal.NCalculReel
  , NatCal.NCalculReelConstant , NatCal.NSolutionEquation , NatCal.NIntegrale
  , NatCal.NTestExistence , NatCal.NSommeIndicee , NatCal.NProduitIndice
  , NatCal.NPartieReelle , NatCal.NPartieImaginaire , NatCal.NModule
  , NatCal.NArgument , NatCal.NCalculComplexe
  , NatCal.NTteFoncRouC , NatCal.NSuiteRecurrenteReelle , NatCal.NSuiteRecurrenteReelle2
  , NatCal.NSuiteRecurrenteReelle3, NatCal.NSuiteRecurrenteComplexe , NatCal.NSuiteRecurrenteComplexe2
  , NatCal.NSuiteRecurrenteComplexe3 , NatCal.NMesureCoefDir , NatCal.NMesureProduitScalaire
  , NatCal.NMaximumFonction , NatCal.NMinimumFonction , NatCal.NAbscisseOrigineRep
  , NatCal.NOrdonneeOrigineRep , NatCal.NUnitexRep , NatCal.NUniteyRep , NatCal.NTestEquivalence
  , NatCal.NTestFact, NatCal.NTestDependanceVariable , NatCal.NTestNatureOperateur);
*/
NatCal.NAutreCalcul = Nat.or(NatCal.NSolutionEquation, NatCal.NIntegrale , NatCal.NTestExistence
  , NatCal.NSommeIndicee , NatCal.NProduitIndice , NatCal.NPartieReelle
  , NatCal.NPartieImaginaire , NatCal.NModule , NatCal.NArgument
  , NatCal.NMesureLongueur , NatCal.NMesureAngleNonOriente , NatCal.NMesureAngleOriente
  , NatCal.NMesureAbscisseSurDroite , NatCal.NMesureAbscisseRepere
  , NatCal.NMesureOrdonneeRepere , NatCal.NMesureLongueurLigne , NatCal.NMesureAirePolygone
  , NatCal.NMesureCoefDir , NatCal.NMesureProduitScalaire , NatCal.NMaximumFonction
  , NatCal.NMinimumFonction , NatCal.NAbscisseOrigineRep , NatCal.NOrdonneeOrigineRep
  , NatCal.NUnitexRep , NatCal.NUniteyRep , NatCal.NTestEquivalence, NatCal.NTestFact
  , NatCal.NTestDependanceVariable , NatCal.NTestNatureOperateur);
NatCal.NTtCalcNomme = Nat.or(NatCal.NCalculReel, NatCal.NCalculReelConstant
  , NatCal.NCalculComplexe, NatCal.NTteFoncRouC
  , NatCal.NSuiteRecurrenteReelle, NatCal.NSuiteRecurrenteReelle2
  , NatCal.NSuiteRecurrenteReelle3, NatCal.NSuiteRecurrenteComplexe
  , NatCal.NSuiteRecurrenteComplexe2, NatCal.NSuiteRecurrenteComplexe3
  , NatCal.NVariable, NatCal.NSolutionEquation, NatCal.NIntegrale
  , NatCal.NTestExistence, NatCal.NSommeIndicee, NatCal.NProduitIndice
  , NatCal.NPartieReelle, NatCal.NPartieImaginaire, NatCal.NModule
  , NatCal.NArgument, NatCal.NMesureCoefDir, NatCal.NMesureLongueurLigne
  , NatCal.NMesureAirePolygone, NatCal.NMesureProduitScalaire
  , NatCal.NMaximumFonction, NatCal.NMinimumFonction, NatCal.NAbscisseOrigineRep
  , NatCal.NOrdonneeOrigineRep, NatCal.NUnitexRep, NatCal.NUniteyRep
  , NatCal.NTestEquivalence, NatCal.NTestFact, NatCal.NTestDependanceVariable, NatCal.NTestNatureOperateur);
NatCal.NCalcOuFoncNonConstante = Nat.or(NatCal.NCalculReel , NatCal.NCalculComplexe
  , NatCal.NTteFoncR , NatCal.NTteFoncC);
// Modification pour la version 3.1.5. On peut aussi choisir une variable comme objet final
// à condition qu'elle ait d'abord été choisie dans les objets sources.
NatCal.NTtCalcouFoncRouC = Nat.or(NatCal.NCalculReelConstant , NatCal.NCalculReel
  , NatCal.NCalculComplexe , NatCal.NFonction, NatCal.NFoncPlusieursVar
  , NatCal.NFonctionComplexe , NatCal.NFonctionComplexe2Var
  , NatCal.NFonctionComplexe3Var);
NatCal.NCalcouFoncParFormule = Nat.or(NatCal.NCalcRouC, NatCal.NFonction
  , NatCal.NFoncPlusieursVar, NatCal.NFonctionComplexe, NatCal.NFonctionComplexe2Var , NatCal.NFonctionComplexe3Var);
NatCal.NTteSuiteRecR = Nat.or(NatCal.NSuiteRecurrenteReelle , NatCal.NSuiteRecurrenteReelle2
  , NatCal.NSuiteRecurrenteReelle3);
NatCal.NTteSuiteRecC = Nat.or(NatCal.NSuiteRecurrenteComplexe
  , NatCal.NSuiteRecurrenteComplexe2 , NatCal.NSuiteRecurrenteComplexe3);

module.exports = NatCal


// WEBPACK FOOTER //
// ./src/types/NatCal.js